import React from 'react'
import PropTypes from 'prop-types'
import { Teaser } from './custom.styled'
import placeholder from '../../../images/placeholder.jpg'

const Customer = ({ customer, isSlider, grid = 4, hidden = false }) => {
  return (
    customer && (
      <Teaser isSlider={isSlider} grid={grid} hidden={hidden}>
        <img
          src={
            customer._embedded['wp:featuredmedia'] !== undefined
              ? customer._embedded['wp:featuredmedia'][0].source_url
              : placeholder
          }
        />
      </Teaser>
    )
  )
}

Customer.propTypes = {
  customer: PropTypes.object,
  isSlider: PropTypes.bool,
  grid: PropTypes.number,
  hidden: PropTypes.bool,
}

export default Customer
